import { useEffect } from 'react';
import qs from 'qs';

/**
 * This hook is used to verify the user's access token and guest access hash. If none of them are present we will call the onError callback.
 *
 * @param {Object{ vepTokens, onError }} props - A props list with the current VEP tokens and a callback for error handling.
 * @return {null} - No return value.
 */
const useCallErrorIfNoGahOrAccessTokenPresent = ({ onError, vepTokens }) => {
    useEffect(() => {
        const queryParams = qs.parse(window.location.search, {
            ignoreQueryPrefix: true,
        });
        const queryGuestAccessHash = queryParams['guest-access-hash'];

        if (!queryGuestAccessHash && !vepTokens?.accessToken) {
            // eslint-disable-next-line no-unused-expressions
            onError?.();
        }
    }, [vepTokens?.accessToken]);
};

export default useCallErrorIfNoGahOrAccessTokenPresent;
